import {FC, useEffect} from 'react';
import {Box} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {transactionsApi} from 'src/api/transactions';
import {store} from 'src/app/store';
import {PageHeader} from 'src/components/common/PageHeader';
import {ChargingSessionDetails} from 'src/components/chargingSessions/ChargingSessionDetails';
import {preloaderChangeStatus} from 'src/stores/common/commonSlice';
import {isErrorObject} from 'src/utils/helper';
import {NotifyError} from 'src/utils/notification';

export const ChargingSessionInfo: FC = () => {
    const intl = useIntl();
    const params = useParams();
    const navigate = useNavigate();
    const [trigger, response] = transactionsApi.useLazyGetTransactionByIdQuery();

    useEffect(() => {
        // A malformed URL, not a permission question: the route guard settled the latter before this
        // component mounted.
        if (!params?.id) {
            navigate('/404');
            return;
        }
        void fetchTransaction();
    }, [params?.id]);

    const fetchTransaction = async () => {
        if (!params?.id) return;

        store.dispatch(preloaderChangeStatus(true));
        try {
            await trigger(+params.id).unwrap();
        } catch (error) {
            if (isErrorObject(error)) {
                NotifyError(error.data.message);
            }
            navigate('/app/charging-sessions');
        } finally {
            store.dispatch(preloaderChangeStatus(false));
        }
    };

    const transaction = response.data;

    return (
        <Box>
            <PageHeader
                title={intl.formatMessage({id: 'chargingSessionDetails'})}
                onlyTitle
            />
            {/* No side padding of its own below a desktop: the shell's column is already the width
                of the screen, and 24px here put the record back inside a margin it had just left. */}
            <Box sx={{p: {xs: 0, md: 3}}}>
                {transaction && <ChargingSessionDetails transaction={transaction}/>}
            </Box>
        </Box>
    );
};